import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Layers } from "lucide-react";
import { api, fmtPrice } from "../lib/api";
import { useCart } from "../context/CartContext";
import { handleImgError } from "../lib/imgFallback";
import { toast } from "sonner";

export default function FrequentlyBought({ product }) {
  const { addItem } = useCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!product?.slug) return;
    api.get(`/products/${product.slug}/frequently-bought`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [product?.slug]);

  if (items.length === 0) return null;
  const bundle = [product, ...items];
  const total = bundle.reduce((s, p) => s + (p.price || 0), 0);

  const addAll = () => {
    bundle.forEach((p) => addItem(p, 1));
    toast.success("Bundle added to cart");
  };

  return (
    <section data-testid="frequently-bought" className="border-t border-white/10 pt-12 mt-12">
      <div className="flex items-center gap-2 mb-8">
        <Layers className="h-4 w-4 text-[#4ADE80]" />
        <h2 className="font-display text-xl tracking-tight text-[#F5F5F5]">Frequently Bought Together</h2>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center gap-6">
        <div className="flex items-center gap-3 flex-wrap">
          {bundle.map((p, i) => (
            <React.Fragment key={p.slug}>
              <Link to={`/products/${p.slug}`} data-testid={`fbt-${p.slug}`} className="w-24 group">
                <div className="aspect-square bg-[#0F0F10] border border-white/[0.06] overflow-hidden">
                  <img src={p.image} alt={p.name} onError={handleImgError} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <p className="mt-2 text-[11px] text-[#A8A8A8] truncate">{p.name}</p>
              </Link>
              {i < bundle.length - 1 && <Plus className="h-4 w-4 text-[#7a7a7a] shrink-0" />}
            </React.Fragment>
          ))}
        </div>
        <div className="lg:ml-6 lg:border-l lg:border-white/10 lg:pl-8">
          <p className="text-[11px] uppercase tracking-[0.18em] text-[#A8A8A8]">Bundle total</p>
          <p className="font-display text-2xl text-[#F5F5F5] mt-1">{fmtPrice(total)}</p>
          <button data-testid="add-bundle-btn" onClick={addAll} className="btn-press mt-4 bg-[#4ADE80] text-[#0F0F10] uppercase tracking-[0.16em] text-[11px] px-6 py-3 hover:bg-[#6FE998]">
            Add All {bundle.length} to Cart
          </button>
        </div>
      </div>
    </section>
  );
}
